import { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@material-ui/core';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useDispatch } from 'react-redux';
import { setOpenSnackbar } from '../../../store/slices/snackbarSlice';
import useVrackApi from '../../../hooks/useVrackApi';
import ConfirmDialog from '../../ConfirmDialog';

RemoveGlobalAdminButton.propTypes = {
  username: PropTypes.string.isRequired,
  onRemoved: PropTypes.func.isRequired
};

export default function RemoveGlobalAdminButton({ username, onRemoved }) {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { fetchData } = useVrackApi('delete', '/admin/global-admins');

  const handleRemove = async () => {
    setLoading(true);
    try {
      await fetchData({ data: { username } });
      dispatch(setOpenSnackbar({ message: 'Global admin removed successfully!' }));
      setOpenConfirm(false);
      onRemoved();
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message || error?.message || 'Failed to remove global admin';
      dispatch(setOpenSnackbar({ message: errorMessage, severity: 'error' }));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Tooltip title="Remove">
        <IconButton
          size="small"
          onClick={() => setOpenConfirm(true)}
          disabled={loading}
          color="primary"
        >
          <DeleteOutlineIcon />
        </IconButton>
      </Tooltip>
      <ConfirmDialog
        isOpen={openConfirm}
        title="Remove Global Admin?"
        content="Are you sure you wish to remove this global admin?"
        onConfirmHandler={handleRemove}
        onCancelHandler={() => setOpenConfirm(false)}
      />
    </>
  );
}
